// Website Whitelabel Script

(function() {
    const replace_text = function (text) {
        if (!text) return text;
        if (typeof text !== "string") return text;
        return text
            .replace(/Frappe Framework/g, "AiBizz Hub Framework")
            .replace(/ERPNext Framework/g, "AiBizzApp Framework")
            .replace(/ERPNext/g, "AiBizzApp")
            .replace(/Frappe/g, "AiBizzApp");
    };

    const walk_and_replace = function (element) {
        if (!element) return;
        // Skip scripts, styles, etc.
        if (["SCRIPT", "STYLE", "NOSCRIPT", "IFRAME", "OBJECT"].includes(element.tagName)) {
            return;
        }
        
        // Replace text nodes
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
        let node;
        while ((node = walker.nextNode())) {
            if (node.nodeValue && (node.nodeValue.includes("ERPNext") || node.nodeValue.includes("Frappe"))) {
                node.nodeValue = replace_text(node.nodeValue);
            }
        }
        
        // Replace placeholders
        if (element.placeholder && (element.placeholder.includes("ERPNext") || element.placeholder.includes("Frappe"))) {
            element.placeholder = replace_text(element.placeholder);
        }
        // Replace titles
        if (element.title && (element.title.includes("ERPNext") || element.title.includes("Frappe"))) {
            element.title = replace_text(element.title);
        }
    };

    const setup_observer = function () {
        const targetNode = document.body;
        if (!targetNode) return;
        const config = { childList: true, subtree: true, characterData: true };

        const callback = function (mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.TEXT_NODE) {
                            if (node.nodeValue && (node.nodeValue.includes("ERPNext") || node.nodeValue.includes("Frappe"))) {
                                node.nodeValue = replace_text(node.nodeValue);
                            }
                        } else if (node.nodeType === Node.ELEMENT_NODE) {
                            walk_and_replace(node);
                        }
                    });
                } else if (mutation.type === "characterData") {
                    if (mutation.target.nodeValue && (mutation.target.nodeValue.includes("ERPNext") || mutation.target.nodeValue.includes("Frappe"))) {
                        mutation.target.nodeValue = replace_text(mutation.target.nodeValue);
                    }
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    };

    document.addEventListener("DOMContentLoaded", function() {
        walk_and_replace(document.body);
        setup_observer();
        
        if (document.title.includes("ERPNext") || document.title.includes("Frappe")) {
            document.title = replace_text(document.title);
        }
    });

    // Also run immediately for existing elements (in case script is loaded later)
    if (document.readyState === "complete" || document.readyState === "interactive") {
        walk_and_replace(document.body);
        setup_observer();
        if (document.title.includes("ERPNext") || document.title.includes("Frappe")) {
            document.title = replace_text(document.title);
        }
    }
})();
